var _style, _circle, _path, _path2, _path3, _path4, _path5, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg2NdEng = function Svg2NdEng(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 138.8 66.8"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".2nd_eng_svg__st4{fill:#e2b128}")), /*#__PURE__*/React.createElement("g", {
    id: "2nd_eng_svg___x32_nd_x5F_eng",
    fill: "#E2B128"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.4 63.3 118.9-.1c1.1 0 2.2-.4 2.7-1 0 0 8.3-13.2 8.3-13.9V19.5c0-.8-8.3-14.1-8.3-14.1-.5-.7-1.6-1.1-2.7-1.1H4.4z",
    style: {
      fill: "#010101"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 127.6,
    cy: 33.8,
    r: 3.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.023 63.325v-59h13.9v59zM45.345 63.247v-59h13.9v59zM27.67 63.27v-59h13.9v59z",
    className: "2nd_eng_svg__st4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "2nd_eng_svg__XMLID_12_",
    d: "M70.1 33.9c-.6 1.2-1.6 3.7-1.4 4.7.2.9.3 1.7 1.8 1.7 1.4 0 3.4-1.9 3.5-2.8.1-1.1-1.4-2.7-2.2-3.6-.5.3-.2 0-.9 0-.4.1-.4.2-.8 0",
    className: "2nd_eng_svg__st4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "2nd_eng_svg__XMLID_11_",
    d: "M64.1 32c.7.9 3.9 1.2 5.3 1.1v-.2c0-.8-.4-.6.3-1.1-.6-1.2-2.3-3.5-2.7-3.9-.8-.7-1.6-1-2.6-.1-1.1.9-1.1 3.5-.3 4.2",
    className: "2nd_eng_svg__st4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "2nd_eng_svg__XMLID_10_",
    d: "M72.4 33.3c1.5.1 4.9-.6 5.5-.8 1-.4 1.7-.9 1.1-2.1s-3.3-2.1-4.3-1.7c-.6.2-2.2 1.9-2.8 2.9.7.5 1 1.4 0 1.5-.8 0 .5.1.5.2",
    className: "2nd_eng_svg__st4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "2nd_eng_svg__XMLID_9_",
    d: "M72.7 32.7c0-.9-.8-1.6-1.9-1.6-1 0-1.9.7-1.9 1.6s.8 1.6 1.9 1.6c1.1.1 1.9-.7 1.9-1.6m-1.3 0c0 .3-.2.5-.5.5s-.5-.2-.5-.5.2-.5.5-.5c.3.1.5.3.5.5",
    className: "2nd_eng_svg__st4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.9,
    cy: 32.8,
    className: "2nd_eng_svg__st4",
    rx: 1,
    ry: 0.8
  }))));
};
export default Svg2NdEng;